// Profile completeness check shared by the student list, the view dialog and
// anywhere else we want to nudge the operator. A student is treated as
// "complete" once Personal Info AND at least one Guardian have their core
// fields filled in. The goal is operational — encourage staff to circle back
// and complete the profile after a fast initial enrollment.

export const PROFILE_PERSONAL_FIELDS = [
  "last_name", "birthday", "address", "city", "province",
];

export function getProfileIssues(student) {
  if (!student) return [];
  const issues = [];
  for (const f of PROFILE_PERSONAL_FIELDS) {
    if (!String(student[f] || "").trim()) issues.push(f);
  }
  const g = (student.guardians || [])[0] || {};
  if (!String(g.name || "").trim()) issues.push("guardian_name");
  if (!String(g.phone || "").trim()) issues.push("guardian_phone");
  return issues;
}

export function isProfileIncomplete(student) {
  return getProfileIssues(student).length > 0;
}

const FIELD_LABELS = {
  last_name: "Last Name",
  birthday: "Birthday",
  address: "Address",
  city: "City / Town",
  province: "Province",
  guardian_name: "Guardian Name",
  guardian_phone: "Guardian Phone",
};

export function profileIssueLabels(student) {
  return getProfileIssues(student).map((k) => FIELD_LABELS[k] || k);
}
